export default class D2cInfo {
  static init() {
    if (
      !TMON.oApp.htStorage.d2cInfo ||
      !TMON.oApp.htStorage.d2cInfo.data ||
      !Object.keys(TMON.oApp.htStorage.d2cInfo.data).length ||
      !TMON.oApp.htStorage.d2cInfo.data.chnlVw === 'N'
    )
      return;
    const d2cHomeMove = document.querySelector('#d2c_home_move');
    const d2cHome = document.querySelector('.d2c_home');
    const child = new D2cInfo();
    d2cHomeMove.innerHTML = child.topInforender();
    d2cHome.innerHTML = child.bottomInfoRender();
  }

  topInforender() {
    const {
      data: { chnlTitle, chnlEn, chnlIconImg, chnlCouponExistYn },
    } = TMON.oApp.htStorage.d2cInfo;
    return `   
    	<div class="d2c_home_move">
        <a href="${this.randingBrandHome(
          chnlEn
        )}" class="d2c_home_link" tl:area='DCCNH'>
          <strong class="blind">통합 채널 홈으로 이동</strong>
          <!-- 채널홈 프로필 -->
          <div class="d2c_profile">
            <div class="d2c_profile_thumb">
              <img src="${chnlIconImg}" alt="채널홈 썸네일 이미지">
            </div>
            <div class="d2c_profile_info">
              <strong class="d2c_profile_title">${chnlTitle}</strong>
              ${
                chnlCouponExistYn === 'Y'
                  ? '<span class="d2c_icon_benefit" aria-label="혜택"></span>'
                  : ''
              }
            </div>
          </div>
        </a>
      </div>
      <div class="d2c_line"></div>`;
  }

  bottomInfoRender() {
    const {
      data: { chnlTitle, chnlEn, chnlIconImg, chnlRate },
    } = TMON.oApp.htStorage.d2cInfo;
    return `
    <div class="d2c_profile">
      <div class="d2c_profile_thumb">
        <img src="${chnlIconImg}" alt="채널홈 썸네일 이미지">
      </div>
      <div class="d2c_profile_info">
        <strong class="d2c_profile_title">${chnlTitle}</strong>  
      </div>
      ${chnlRate && `<span class="d2c_profile_score">${chnlRate}</span>`}
    
    </div>
    <a href="${this.randingBrandHome(
      chnlEn
    )}" class="d2c_home_button" tl:area='DCCNH2'>브랜드 홈 방문</a>
    `;
  }

  randingBrandHome(chnlEn) {
    return TMON.view_mode === 'app'
      ? `javascript:TMON.app.callApp('webview', 'goD2CChannelHome', '${chnlEn}')`
      : `${TMON.htLocal.htURL.home}/m/brand/${chnlEn}`;
  }
}
